@if (authService.currentUser()?.email && !authService.currentUser()?.emailVerified) {
  <div class="w-full bg-[#fff8e1] border-b-[1px] border-solid border-[#f0d98c] py-[10px] px-[15px] flex flex-wrap items-center justify-center gap-[10px] text-[13px] text-[#7a5c00] text-center">
    <i class="ri-mail-unread-line text-[16px]"></i>
    <span>Please verify your email address ({{ authService.currentUser()?.email }}) to keep your account secure.</span>
    @if (emailVerifyService.canResend()) {
      <button type="button" (click)="emailVerifyService.resend()" class="font-medium text-[#64b496] underline">
        {{ emailVerifyService.isResending() ? 'Sending...' : 'Resend email' }}
      </button>
    } @else {
      <span class="text-[#9c8a4d]">Resend available in {{ emailVerifyService.cooldownSecondsLeft() }}s</span>
    }
    @if (emailVerifyService.resendMessage()) {
      <span class="text-[#3f7d3f] font-medium">{{ emailVerifyService.resendMessage() }}</span>
    }
  </div>
}
